(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /**
   * Contact form polish. The form posts natively (Shopify handles spam checks + email);
   * this only adds feedback around it:
   *  - submit → button goes busy (aria-busy) so it can't be double-sent
   *  - a field the browser rejects shakes once (first invalid field only)
   *  - after a post, focus moves to the success / error note so screen readers announce it
   */
  class ContactInquiry extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('button[type="submit"]');

      this.onSubmit = () => {
        this.button?.setAttribute('aria-busy', 'true');
      };
      this.onInvalid = (event) => {
        if (this.shookThisRound) return;
        this.shookThisRound = true;
        requestAnimationFrame(() => (this.shookThisRound = false));
        const field = event.target.closest('.field, .inquiry__options');
        if (!field) return;
        field.classList.remove('is-shaking');
        void field.offsetWidth;
        field.classList.add('is-shaking');
        field.addEventListener('animationend', () => field.classList.remove('is-shaking'), { once: true });
      };
      this.onPageShow = (event) => {
        if (event.persisted) this.button?.removeAttribute('aria-busy');
      };

      // Browsers can't require "at least one" of a checkbox group, so flag the first box until one is ticked.
      this.groups = [...this.form.querySelectorAll('[data-required-group]')].map((group) => {
        const boxes = [...group.querySelectorAll('input[type="checkbox"]')];
        this.wireOther(group);
        const sync = () => boxes[0]?.setCustomValidity(boxes.some((box) => box.checked) ? '' : 'Pick at least one.');
        group.addEventListener('change', sync);
        sync();
        return { group, sync };
      });

      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('invalid', this.onInvalid, true);
      window.addEventListener('pageshow', this.onPageShow);

      const note = this.querySelector('[data-success], [data-error]');
      if (note) note.focus({ preventScroll: true });
    }

    /** "Other" ticked → open a text box for it; it's required while open and only posts when ticked. */
    wireOther(group) {
      const toggle = group.querySelector('[data-other-toggle]');
      const panel = group.querySelector('[data-other]');
      const input = panel?.querySelector('input');
      if (!toggle || !panel || !input) return;
      const update = (focus) => {
        const open = toggle.checked;
        panel.classList.toggle('is-open', open);
        panel.inert = !open;
        input.disabled = !open;
        input.required = open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open && focus) input.focus({ preventScroll: true });
      };
      toggle.addEventListener('change', () => update(true));
      update(false);
    }

    disconnectedCallback() {
      this.groups?.forEach(({ group, sync }) => group.removeEventListener('change', sync));
      this.form?.removeEventListener('submit', this.onSubmit);
      this.form?.removeEventListener('invalid', this.onInvalid, true);
      window.removeEventListener('pageshow', this.onPageShow);
    }
  }

  if (!customElements.get('contact-inquiry')) customElements.define('contact-inquiry', ContactInquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('#MobileMenu');
      this.toggle = this.querySelector('[data-menu-open]');
      this.toggle?.addEventListener('click', () => this.openMenu());
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.closeMenu());
      this.menu?.addEventListener('close', () => this.toggle?.setAttribute('aria-expanded', 'false'));
      this.menu?.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.menu.close();
      });

      // Cart link opens the drawer when one exists on the page.
      this.querySelector('[data-cart-link]')?.addEventListener('click', (event) => {
        if (!document.querySelector('cart-drawer')) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });

      this.lastY = window.scrollY;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const y = window.scrollY;
        this.classList.toggle('is-scrolled', y > 8);
        if (this.dataset.hideOnScroll === 'true') {
          const goingDown = y > this.lastY + 4;
          const goingUp = y < this.lastY - 4;
          if (goingDown && y > 240) this.classList.add('is-hidden');
          if (goingUp || y < 240) this.classList.remove('is-hidden');
        }
        this.lastY = y;
      });
    }

    openMenu() {
      this.menu?.showModal();
      this.toggle?.setAttribute('aria-expanded', 'true');
    }

    closeMenu() {
      this.menu?.close();
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * Collection tabs: a single marker slides to the tapped tab while the next collection loads.
   * The tabs are plain links — navigation is never blocked; the slide is just immediate feedback.
   */
  class ShopTabs extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.shop-tabs__list');
      this.tabs = [...this.querySelectorAll('.shop-tabs__tab')];
      const current = this.tabs.find((tab) => tab.getAttribute('aria-current') === 'page');
      if (!this.list || !current) return;

      this.place(current);
      this.classList.add('is-ready');
      current.scrollIntoView({ block: 'nearest', inline: 'center' });

      this.onClick = (event) => {
        const tab = event.target.closest('.shop-tabs__tab');
        if (!tab || tab === current || event.metaKey || event.ctrlKey || event.shiftKey) return;
        if (!window.LovedOnes?.motion) return;
        this.classList.add('is-animating');
        this.place(tab);
      };
      this.list.addEventListener('click', this.onClick);

      this.resizeObserver = new ResizeObserver(() => this.place(this.active || current));
      this.resizeObserver.observe(this.list);

      // Back/forward cache: restore the marker to the real current tab.
      this.onPageShow = (event) => {
        if (!event.persisted) return;
        this.classList.remove('is-animating');
        this.place(current);
      };
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.list?.removeEventListener('click', this.onClick);
      this.resizeObserver?.disconnect();
      window.removeEventListener('pageshow', this.onPageShow);
    }

    place(tab) {
      this.active = tab;
      this.tabs.forEach((t) => t.classList.toggle('is-marked', t === tab));
      const width = this.list.offsetWidth;
      const left = tab.offsetLeft;
      const right = width - (left + tab.offsetWidth);
      this.style.setProperty('--marker-left', `${left}px`);
      this.style.setProperty('--marker-right', `${right}px`);
    }
  }

  if (!customElements.get('shop-tabs')) customElements.define('shop-tabs', ShopTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      const data = JSON.parse(this.querySelector('[data-product-json]')?.textContent || '{}');
      this.variants = data.variants || [];
      this.moneyFormat = data.moneyFormat || '';
      this.form = document.getElementById(this.dataset.form);
      this.gallery = this.querySelector('product-gallery');
      this.button = this.querySelector('[data-atc]');
      this.variant = this.currentVariant();

      this.addEventListener('change', this.onChange);
      this.form?.addEventListener('submit', this.onSubmit);
    }

    /* ─── Variants ─────────────────────────────────────── */
    selectedOptions() {
      return [...this.querySelectorAll('.opt')].map(
        (fieldset) => fieldset.querySelector('.opt__input:checked')?.dataset.value ?? null
      );
    }

    currentVariant() {
      const options = this.selectedOptions();
      if (!options.length) {
        const id = Number(this.form?.querySelector('[name="id"]')?.value);
        return this.variants.find((v) => v.id === id) || this.variants[0];
      }
      return this.variants.find((v) => v.options.every((value, i) => value === options[i]));
    }

    onChange = (event) => {
      if (event.target.matches('.opt__input')) this.onVariantChange();
      if (event.target.matches('.qty__input')) this.updateButton();
    };

    onVariantChange() {
      const variant = this.currentVariant();
      this.variant = variant;
      this.hideError();

      const hidden = this.form?.querySelector('[data-variant-input]');
      if (hidden && variant) hidden.value = variant.id;

      this.markAvailability();
      this.updatePrice();
      this.updateButton();

      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url);
        if (variant.featured_media) this.gallery?.show(variant.featured_media.id);
      }
    }

    /** Multi-option products: grey out values with no available combination. */
    markAvailability() {
      const fieldsets = [...this.querySelectorAll('.opt')];
      if (fieldsets.length < 2) return;
      const selected = this.selectedOptions();
      fieldsets.forEach((fieldset, position) => {
        fieldset.querySelectorAll('.opt__input').forEach((input) => {
          const available = this.variants.some(
            (v) =>
              v.available &&
              v.options[position] === input.dataset.value &&
              v.options.every((value, i) => i === position || value === selected[i])
          );
          input.nextElementSibling?.toggleAttribute('data-unavailable', !available);
        });
      });
    }

    updatePrice() {
      const el = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare]');
      if (!this.variant || !el) return;
      const next = this.money(this.variant.price);
      if (el.textContent.trim() !== next) {
        el.textContent = next;
        LovedOnes.bump?.(el);
      }
      const onSale = this.variant.compare_at_price > this.variant.price;
      if (compare) {
        compare.hidden = !onSale;
        if (onSale) compare.textContent = this.money(this.variant.compare_at_price);
      }
      this.querySelector('[data-price-wrap]')?.classList.toggle('is-on-sale', onSale);
      const badge = this.querySelector('[data-sale-badge]');
      if (badge && badge.hidden === onSale) {
        badge.hidden = !onSale;
        if (onSale) LovedOnes.bump?.(badge);
      }
    }

    quantity() {
      return Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value) || 1);
    }

    updateButton({ busy = false } = {}) {
      const button = this.button;
      if (!button) return;
      const text = button.querySelector('[data-atc-text]');
      const price = button.querySelector('[data-atc-price]');
      const amount = button.querySelector('[data-atc-amount]');
      const note = this.querySelector('[data-sold-out-note]');
      const available = Boolean(this.variant?.available);

      button.disabled = !available;
      // Nothing to choose a quantity of when it's sold out.
      const qty = this.querySelector('.product__qty');
      if (qty) qty.inert = !available;
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
      button.classList.toggle('btn--blue', busy);
      button.classList.toggle('btn--red', !busy);

      text.textContent = busy
        ? button.dataset.labelAdding
        : available
          ? button.dataset.labelAdd
          : button.dataset.labelSoldOut;
      if (note) note.hidden = available || !this.variant;
      if (price) price.hidden = busy || !available;
      if (amount && this.variant) {
        const next = this.money(this.variant.price * this.quantity());
        if (amount.textContent.trim() !== next) {
          amount.textContent = next;
          if (!busy) LovedOnes.bump?.(amount);
        }
      }
    }

    /* ─── Add to cart ──────────────────────────────────── */
    onSubmit = async (event) => {
      event.preventDefault();
      if (this.busy || !this.variant?.available || !window.LovedOnes?.cart) return;
      this.busy = true;
      this.hideError();
      this.updateButton({ busy: true });

      try {
        await LovedOnes.cart.add(this.form, this);
        const target = document.querySelector('[data-cart-link]');
        await LovedOnes.flyTo(this.gallery?.frontImage, target);
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          window.location.href = this.dataset.cartUrl;
        }
      } catch (error) {
        this.showError(error.message);
      } finally {
        this.busy = false;
        this.updateButton();
      }
    };

    showError(message) {
      const box = this.querySelector('[data-atc-error]');
      if (!box) return;
      const detail = box.querySelector('[data-atc-error-detail]');
      if (detail) detail.textContent = message && message !== 'Cart request failed' ? message : '';
      box.hidden = false;
    }

    hideError() {
      const box = this.querySelector('[data-atc-error]');
      if (box) box.hidden = true;
    }

    /* ─── Money ────────────────────────────────────────── */
    money(cents) {
      const value = Number(cents) / 100;
      const fmt = (decimals, thousands, decimal) => {
        const [whole, fraction] = value.toFixed(decimals).split('.');
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
      };
      const formats = {
        amount: () => fmt(2, ',', '.'),
        amount_no_decimals: () => fmt(0, ',', '.'),
        amount_with_comma_separator: () => fmt(2, '.', ','),
        amount_no_decimals_with_comma_separator: () => fmt(0, '.', ','),
        amount_with_apostrophe_separator: () => fmt(2, "'", '.'),
        amount_no_decimals_with_space_separator: () => fmt(0, ' ', ','),
        amount_with_space_separator: () => fmt(2, ' ', ','),
        amount_with_period_and_space_separator: () => fmt(2, ' ', '.'),
      };
      if (!this.moneyFormat) return `$${formats.amount()}`;
      return this.moneyFormat
        .replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (formats[key] || formats.amount)())
        .replace(/<[^>]*>/g, '');
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  /*
   * A view-transition-name must be unique per page. If this product already appears with the
   * same name elsewhere (e.g. the featured coffee), drop it here so the morph still works there.
   */
  class ProductGrid extends HTMLElement {
    connectedCallback() {
      const names = new Set();
      document.querySelectorAll('[style*="view-transition-name"]').forEach((el) => {
        const name = el.style.viewTransitionName;
        if (!name || name === 'none') return;
        if (names.has(name) && this.contains(el)) {
          el.style.viewTransitionName = 'none';
          return;
        }
        names.add(name);
      });
    }
  }

  if (!customElements.get('product-grid')) customElements.define('product-grid', ProductGrid);

  } catch(e) { console.error(e); }
})();
})();
